const getPropsTagChipOverdue = (overdue) => {
  const label = overdue ? 'Inadimplente' : 'Adimplente';
  const kind = overdue ? 'warning' : 'success';

  return { label, kind };
};

export default getPropsTagChipOverdue;
